// Texts of the site-wide cookie & storage banner (portfolio page and calculator).
// German is the source; `en` must carry the same keys.

export const consentDe = {
  'consent.title': 'Cookies & Speicherung',
  'consent.body':
    'Diese Website verwendet keine Cookies und kein Tracking. Im Finanzrechner können Ihre Eingaben und Einstellungen (Sprache, Design) auf Wunsch lokal in Ihrem Browser gespeichert werden, damit sie beim nächsten Besuch wieder da sind. Dabei werden keine Daten an uns oder an Dritte übertragen.',
  'consent.allow': 'Speichern erlauben',
  'consent.deny': 'Nicht speichern',
  'consent.hint': 'Ihre Wahl gilt für die ganze Website und lässt sich jederzeit über „Cookie-Einstellungen“ am Seitenende ändern.',
  'consent.currentGranted': 'Aktuell: Der Finanzrechner speichert Ihre Eingaben in diesem Browser.',
  'consent.currentDenied': 'Aktuell: Es wird nichts gespeichert.',
  'consent.close': 'Schließen',
  'consent.settings': 'Cookie-Einstellungen',
} as const;

export type ConsentTranslationKey = keyof typeof consentDe;

export const consentEn: Record<ConsentTranslationKey, string> = {
  'consent.title': 'Cookies & storage',
  'consent.body':
    'This website uses no cookies and no tracking. In the financial calculator, your inputs and settings (language, theme) can be saved locally in your browser if you like, so they are still there on your next visit. No data is sent to us or to anyone else.',
  'consent.allow': 'Allow saving',
  'consent.deny': "Don't save",
  'consent.hint': 'Your choice applies to the whole website and can be changed at any time via “Cookie settings” at the bottom of the page.',
  'consent.currentGranted': 'Currently: the financial calculator saves your inputs in this browser.',
  'consent.currentDenied': 'Currently: nothing is saved.',
  'consent.close': 'Close',
  'consent.settings': 'Cookie settings',
};

export function consentText(locale: 'de' | 'en', key: ConsentTranslationKey): string {
  return (locale === 'de' ? consentDe : consentEn)[key];
}
